module.exports = __webpack_public_path__ + "media/images/country_flags/bs-d123b7573e41d0d8a297c076935f3435.png";